import { useUser } from '../../app/UserContext';
import { useNotifications } from './useNotifications';
import './Notifications.css';

/**
 * The one-time ask, shown after the app is installed and opened.
 *
 * Deliberately a sheet rather than a banner: the browser's own permission dialog
 * appears on top of it, and people are far more likely to accept that dialog if
 * something already explained what it is for. Asking cold is how you get a
 * permanent denial, which nothing in the app can undo.
 */
export function NotificationPrompt() {
  const { user } = useUser();
  const { status, shouldPrompt, isBusy, enable, dismissPrompt } = useNotifications(user?.id);

  if (!user || !shouldPrompt) return null;

  const needsInstall = status === 'needs-install';

  return (
    <div className="notif-prompt__overlay" role="dialog" aria-modal="true">
      <div className="notif-prompt">
        <div className="notif-prompt__icon" aria-hidden="true">
          🔔
        </div>
        <h2 className="notif-prompt__title">Stay in the loop</h2>

        {needsInstall ? (
          <p className="notif-prompt__body">
            Notifications work once SWOL is on your Home Screen. Tap Share, then{' '}
            <strong>Add to Home Screen</strong>, and open it from there.
          </p>
        ) : (
          <p className="notif-prompt__body">
            Turn on notifications to get updates from SWOL with Friends.
          </p>
        )}

        <div className="notif-prompt__actions">
          {!needsInstall && (
            <button
              type="button"
              className="notif-prompt__enable"
              onClick={() => void enable()}
              disabled={isBusy}
            >
              {isBusy ? 'Just a sec…' : 'Turn on notifications'}
            </button>
          )}
          <button type="button" className="notif-prompt__later" onClick={dismissPrompt}>
            {needsInstall ? 'Got it' : 'Not now'}
          </button>
        </div>

        <p className="notif-prompt__fine">You can change this any time in Settings.</p>
      </div>
    </div>
  );
}
